import React from "react";

const SalaryBreakup = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M22.273 16.515c0 2.453-1.917 4.443-4.282 4.443s-4.283-1.99-4.283-4.443c0-2.455 1.918-4.444 4.283-4.444s4.282 1.99 4.282 4.444Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M10.934 7.5a4.211 4.211 0 0 0 3.02-1.308 4.535 4.535 0 0 0 1.25-3.139.422.422 0 0 0-.091-.264h5.5a.422.422 0 0 0-.088.264c0 1.18.452 2.31 1.256 3.145A4.209 4.209 0 0 0 24.81 7.5c.085 0 .168-.03.235-.082V26.48l.76-.616V3.478a1.51 1.51 0 0 0-.418-1.044A1.402 1.402 0 0 0 24.382 2H11.598c-.377.001-.74.157-1.006.434a1.51 1.51 0 0 0-.418 1.044v22.386l.76.616V7.5Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M26.006 28.248h.052l.23.136c2.703 1.594 4.932 2.829 6.663 3.688l.298.148.53.252.223-.165V15.446c-.932.748-2.066 1.726-3.308 2.8-2.646 2.267-5.79 4.98-9.118 7.338 1.593.983 3.053 1.855 4.43 2.664ZM33.116 33.418a.36.36 0 0 0-.195-.198c-3.033-1.47-7.383-3.981-11.94-6.794a3.97 3.97 0 0 0-1.25-.504 4.025 4.025 0 0 0-.796-.082h-1.87c-.723 0-1.433.202-2.054.586-4.56 2.813-8.911 5.323-11.94 6.794a.418.418 0 0 0-.208.455c.039.184.191.317.372.325H32.75a.394.394 0 0 0 .336-.187.427.427 0 0 0 .03-.395ZM2.745 32.22l.298-.15c1.815-.896 4.16-2.196 7.025-3.902l1.508-.892v.025l1.35-.826.095-.058c.45-.272.911-.553 1.377-.826-3.316-2.358-6.46-5.07-9.09-7.338C4.065 17.18 2.918 16.19 2 15.453V32.31l.223.165.521-.256ZM26.82 9.855v10.22a158.93 158.93 0 0 0 1.743-1.494c1.77-1.516 3.299-2.845 4.529-3.75L26.82 9.855ZM9.168 9.855l-6.272 4.976c1.23.904 2.786 2.238 4.529 3.75.557.479 1.138.983 1.743 1.494V9.855Z"
            fill={fill}
        />
    </svg>
);

export default SalaryBreakup;